import { useEffect, useRef, useState } from 'react';

import { formatUSDNoDecimals } from '../../helpers/helperFunctions';
import { CaptionText, H3, H4, P1, P3 } from '../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { ENTRY_PACKAGE } from '../../routes/routes';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';
import { Icon, IconPortfolioOrders } from '../../styles/Icons';
import { Overlay } from './Overlay';
import { getMyHubsEntryOne } from './Portfolio.actions';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';
import { PortfolioItem } from './PortfolioItem';
import { PortfolioTradingItem } from './PortfolioTradingItem';

export const GuardianSummary = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const ref = useRef<any>(null);

  const [expanded, setExpanded] = useState(true);

  const { entryOne } = useAppSelector((state) => state.portfolio);

  useEffect(() => {
    dispatch(getMyHubsEntryOne());
  }, [dispatch]);

  const [height, setHeight] = useState(ref?.current?.clientHeight);

  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
  }, [entryOne]);

  return (
    <>
      <Flexed mb='20' center between rowSM>
        <H3 mbSM='10' color={colors.neutral900}>
          My Entry HUB NFTs summary
        </H3>

        <Button
          maxWidth='350px'
          maxWidthSM='100%'
          onClick={() => history.push(ENTRY_PACKAGE)}>
          ADD ENTRY HUB NFT
        </Button>
      </Flexed>
      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total Entry hub NFT orders
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              {formatUSDNoDecimals(
                entryOne?.orders?.summary?.totalOrderAmount || 0
              )}{' '}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <Flexed
        mb='20'
        center
        gap='20px'
        pointer
        onClick={() => setExpanded(!expanded)}>
        <H4>My Entry HUB NFTs</H4>
        <ArrowChevron direction={expanded ? 'up' : 'down'} />
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {entryOne?.orders?.orders?.map((item: any, index: number) => (
            <PortfolioTradingItem key={index} item={item} />
          ))}
        </div>
      </Collapsable>

      <Overlay />
    </>
  );
};
